import React from 'react';
import { Grid, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';

// Components
import ContentContainer from '../components/Layout/ContentContainer';

// Styles
const Root = styled('div')(({ theme }) => ({
  '&': {
    marginTop: theme.spacing(8),
  },
}));

export default function NotFound() {
  return (
    <Root>
      <h1 className="screen-reader-text">
        We couldn&apos;t find that Web page (Error 404) /{' '}
        <span lang="fr">
          Nous ne pouvons trouver cette page Web (Erreur&nbsp;404)
        </span>
      </h1>
      <ContentContainer>
        <Grid container spacing={6}>
          <Grid item md={6}>
            <section>
              <Typography variant="h4" component="h2" color="textPrimary">
                We couldn&apos;t find that Web page (Error&nbsp;404)
              </Typography>
              <Typography variant="body1" sx={{ mt: 3, mb: 3 }}>
                We&apos;re sorry you ended up here. Sometimes a page gets moved
                or deleted, but hopefully we can help you find what you&apos;re
                looking for. What next?
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1" sx={{ mt: 3, mb: 3 }}>
                    Return to the{' '}
                    <Link
                      component={RouterLink}
                      to="/data-analytics-services/overview"
                      color="inherit"
                    >
                      home page
                    </Link>
                  </Typography>
                </li>
              </ul>
            </section>
          </Grid>
          <Grid item md={6}>
            <section>
              <Typography variant="h4" component="h2" color="textPrimary">
                <span lang="fr">
                  Nous ne pouvons trouver cette page Web (Erreur 404)
                </span>
              </Typography>
              <Typography variant="body1" sx={{ mt: 3, mb: 3 }}>
                <span lang="fr">
                  Nous sommes désolés que vous ayez abouti ici. Il arrive
                  parfois qu&apos;une page ait été déplacée ou supprimée.
                  Heureusement, nous pouvons vous aider à trouver ce que vous
                  cherchez. Que faire?
                </span>
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1" sx={{ mt: 3, mb: 3 }} lang="fr">
                    Retournez à la{' '}
                    <Link
                      component={RouterLink}
                      to="/services-analyse-donnees/apercu"
                      color="inherit"
                    >
                      page d&apos;accueil
                    </Link>
                  </Typography>
                </li>
              </ul>
            </section>
          </Grid>
        </Grid>
      </ContentContainer>
    </Root>
  );
}
